import React from 'react'


export default function LigaVerwaltungFieldDescription({text}) {

    return <div style={{marginTop:5, fontSize:10, opacity:0.8}}>
        {text}
    </div>
}
